import { AnimatePresence, motion } from "framer-motion";
import { floor } from "lodash";
import styled from "styled-components";

interface LoaderProps {
  progress: number;
}

const Wrapper = styled.div`
  position: relative;
  width: 56px;
  height: 56px;
`;

const Text = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 12px;
  transform: translate(-50%, -55%);
`;

const Svg = styled.svg`
  width: 56px;
  height: 56px;
  transform: rotate(-90deg);
  circle {
    width: 100%;
    height: 100%;
  }
`;

const CircleBack = styled.circle`
  fill: none;
  stroke-width: 3;
  stroke: #e3e2e2;
`;

const CircleProgress = styled(motion.circle)<{ progress: number }>`
  fill: none;
  stroke-width: 3;
  stroke: ${({ theme }) => theme.colors.hotPink};
  stroke-linecap: round;
  stroke-dasharray: 100 100;
  transition: stroke-dashoffset 0.2s ease-in-out;
`;

export const Loader: React.FC<LoaderProps> = ({ progress }) => {
  return (
    <Wrapper>
      <Text>{floor(progress * 100)}%</Text>
      <Svg viewBox="-2 -2 36 36">
        <CircleBack cx="16" cy="16" r="15.9155" />
        <CircleProgress
          progress={progress}
          cx="16"
          cy="16"
          r="15.9155"
          initial={{ strokeDashoffset: 100 }}
          animate={{ strokeDashoffset: 100 - progress * 100 }}
        />
      </Svg>
    </Wrapper>
  );
};
